export const Data = [
  {
    type: "zh",
    language:[
      {
        text1:"中文",
        path:"zh"
      },
      {
        text1:"English",
        path:"en"
      }
    ],
    menuData:[{
      headIndex: 1,
      headText:"首页",
      headPath:"/",
    },
      {
        headIndex: 2,
        headText:"产品技术",
        headPath:"/product",
      },
      {
        headIndex: 3,
        headText:"解决方案",
        headPath:"/companyProfile",
      },
      {
        headIndex: 4,
        headText:"临床应用",
        headPath:"/clinicalNew",
      },
      {
        headIndex: 5,
        headText:"关于我们",
        headPath:"/aboutUs",
      },
      {
        headIndex: 6,
        headText:"新闻中心",
        headPath:"/news2",
      },
      {
        headIndex: 7,
        headText:"联系我们",
        headPath:"/contactUs",
      }
    ]
  },
  {
    type: "en",
    language:[
      {
        text1:"中文",
        path:"zh"
      },
      {
        text1:"English",
        path:"en"
      }
    ],

    activeIndex:1,
    menuData:[{
      headIndex: 1,
      headText:"homepage",
      headPath:"/",
    },
      {
        headIndex: 2,
        headText:"Product Technology",
        headPath:"/product",
      },
      {
        headIndex: 3,
        headText:"Solutions",
        headPath:"/companyProfile",
      },
      {
        headIndex: 4,
        headText:"Clinical Applications",
        headPath:"/clinicalNew",
      },
      {
        headIndex: 5,
        headText:"About Us",
        headPath:"/aboutUs",
      },
      {
        headIndex: 6,
        headText:"News Center",
        headPath:"/news2",
      },
      {
        headIndex: 7,
        headText:"Contact Us",
        headPath:"/contactUs",
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/hearder.js